module.exports = __webpack_public_path__ + "img/christopher-avila.b41c7b6a.png";